import angular from "angular";
import {
  machineDetailProgressiveMeterReadingsComponentOptions,
  vsComponentName as machineDetailProgressiveMeterReadingsComponentName,
} from "./component";

export const vsModuleName =
  "SlotTrak.Machines.Common.Machines.ProgressiveMeterReadings";

angular
  .module(vsModuleName, [])
  .component(
    machineDetailProgressiveMeterReadingsComponentName,
    machineDetailProgressiveMeterReadingsComponentOptions
  );
